var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"snt-loading__load",class:_vm.loadClass,style:({minHeight: _vm.minHeight})},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":1,"color":"secondary","indeterminate":""}})],1):_c('div',{class:_vm.contentClass},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }